import { ProjectBasic } from '../../../domain/value-object/ProjectReportVO'
import UserBasicVO from '../../../domain/value-object/UserBasicVO'
import api, { APIResponse } from '../../../lib/commons/api'
import { ProjectStatus } from '../../../lib/functions/project'

export interface ProjectClosingStatusRow {
  uuid: string
  division: string
  project: {
    name: string
    iconUrl?: string
  }
  projectStatus: ProjectStatus
  startDate: string
  endDate: string
  projectManager: UserBasicVO
  closingStatus: boolean
  userCount: number
  approvedUserCount: number
  closingDate: string
  closer: UserBasicVO
}

export interface ProjectClosingStatusResponse {
  uuid: string
  division: string
  project: {
    displayName: string
    iconUrl: string
    status: ProjectStatus
    scheduledDate: {
      startDate: string
      endDate: string
    }
  }
  projectManager: UserBasicVO
  closingStatus: boolean
  userCount: number
  approvedUserCount: number
  closingDate: string
  closer: UserBasicVO
}

export interface ProjectClosingStatusSearchParams {
  startDate: string
  endDate: string
  projectStatus?: string[]
  closingStatus?: boolean[]
}

export interface ProjectClosingStatusCountParams {
  date: string
  projectStatus?: string[]
  closingStatus?: boolean[]
}

export const fetchAllProjectClosingStatus = async (
  startDate: string,
  endDate: string
): Promise<APIResponse> => {
  const params: ProjectClosingStatusSearchParams = {
    startDate: startDate,
    endDate: endDate,
  }
  return api.functional.request(
    'GET',
    '/api/v1/project_closing_status/task_actual_work',
    params
  )
}

export const fetchProjectClosingStatusCount = async (
  date: string,
  searchCondition?: {
    projectStatus?: string[]
    closingStatus?: string[]
  }
): Promise<APIResponse> => {
  const params: ProjectClosingStatusCountParams = {
    date: date,
    projectStatus: [],
    closingStatus: [],
  }

  if (
    searchCondition?.projectStatus &&
    searchCondition.projectStatus.length > 0
  ) {
    params.projectStatus = searchCondition.projectStatus
  }
  if (
    searchCondition?.closingStatus &&
    searchCondition.closingStatus.length > 0
  ) {
    params.closingStatus = searchCondition.closingStatus.map(
      status => status === 'true'
    )
  }

  return api.functional.request(
    'GET',
    '/api/v1/project_closing_status/task_actual_work/count',
    params
  )
}

export const fetchSelectedProjectClosingStatus = async (
  startDate: string,
  endDate: string,
  searchCondition?: {
    projectStatus?: string[]
    closingStatus?: string[]
  }
): Promise<APIResponse> => {
  const params: ProjectClosingStatusSearchParams = {
    startDate: startDate,
    endDate: endDate,
  }

  if (
    searchCondition?.projectStatus &&
    searchCondition.projectStatus.length > 0
  ) {
    params.projectStatus = searchCondition.projectStatus
  }
  if (
    searchCondition?.closingStatus &&
    searchCondition.closingStatus.length > 0
  ) {
    params.closingStatus = searchCondition.closingStatus.map(
      status => status === 'true'
    )
  }

  return api.functional.request(
    'GET',
    '/api/v1/project_closing_status/task_actual_work',
    params
  )
}
